
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";

const RecipeOverview = () => {
  return (
    <Card className="mb-12">
      <CardHeader>
        <CardTitle>Recipe At A Glance</CardTitle>
        <CardDescription>Key details about this recipe</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="text-center">
            <p className="text-lg font-medium">Prep Time</p>
            <p className="text-muted-foreground">30 min</p>
          </div>
          <div className="text-center">
            <p className="text-lg font-medium">Cook Time</p>
            <p className="text-muted-foreground">5-7 min</p>
          </div>
          <div className="text-center">
            <p className="text-lg font-medium">Difficulty</p>
            <p className="text-muted-foreground">Intermediate</p>
          </div>
          <div className="text-center">
            <p className="text-lg font-medium">Yield</p>
            <p className="text-muted-foreground">12-15 cookies</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default RecipeOverview;
